import styled from 'styled-components'

import { media } from 'src/styles/media'
import { Z_INDEX_HEADER } from 'src/constants/z-indexes'

export const HEADER_HEIGHT_DESKTOP = 8.8

export const HeaderWrap = styled.header`
  position: absolute;
  z-index: ${Z_INDEX_HEADER};
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: ${HEADER_HEIGHT_DESKTOP}rem;
  padding: 0 3.2rem;

  ${media.desktop} {
    position: relative;
    z-index: unset;
  }
`

export const LinksWrap = styled.div`
  display: flex;
  justify-content: flex-end;

  ${media.desktop} {
    width: 17.5rem;
  }
`

export const ProgressGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    margin: 0 0 0.4rem 0;
  }
`

export const Button = styled.button`
  padding: 0;

  & + & {
    margin-left: 1.2rem;
  }
`
